import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=22bed8ae&scoped=true&"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=22bed8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bed8ae",
  null
  
)

export default component.exports